import { createReducer } from '@reduxjs/toolkit';

import * as videosActions from './videosActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  type: 'video',
  isActive: false,

  title: '',
  description: '',
  showPlayIcon: true,
  textAlign: 'center',
  layout: 'grid',
  items: [],
};

const videos = createReducer(initialState, (builder) => {
  builder
    .addCase(videosActions.videosStore, (state, { payload: data }) => {
      const { blockId, uid, isActive, videos: videosData } = data;
      const section = videosData ?? {};

      return {
        ...state,
        error: null,
        requesting: false,
        id: blockId ?? 0,
        uid: uid ?? 0,
        isActive: isActive,
        title: section.title ?? '',
        description: section.description ?? '',
        showPlayIcon: section.showPlayIcon ?? true,
        textAlign: section.textAlign ?? 'center',
        layout: section.layout ?? 'grid',
        items: section.items ?? [],
      };
    })
    .addCase(videosActions.videosClear, () => ({ ...initialState }))

    .addCase(videosActions.videosUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(videosActions.videosUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(videosActions.videosUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(videosActions.videosUpdateTitle, (state, { payload }) => ({ ...state, title: payload }))
    .addCase(videosActions.videosUpdateDescription, (state, { payload }) => ({ ...state, description: payload }))
    .addCase(videosActions.videosUpdateShowPlayIcon, (state, { payload }) => ({ ...state, showPlayIcon: payload }))
    .addCase(videosActions.videosUpdateTextAlign, (state, { payload }) => ({ ...state, textAlign: payload }))
    .addCase(videosActions.videosUpdateLayout, (state, { payload }) => ({ ...state, layout: payload }))
    .addCase(videosActions.videosUpdateItems, (state, { payload }) => ({ ...state, items: payload }));
});

export default videos;
